import React, { useState, useEffect } from 'react';
import errorHandler from '../../../utils/errorHandler';
import api from '../../../services/api/axiosConfig';
import Modal from '../../../components/Modal';
import { Spinner } from 'flowbite-react'; // Import Flowbite components for UI feedback


// Mock Label component (dependency)
const Label = ({ htmlFor, label }) => {
  return (
    <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
  );
};

// Mock ShowValidationMessage component (dependency)
const ShowValidationMessage = ({ error }) => {
  return (
    error ? <p className="mt-1 text-sm text-red-600">{error}</p> : null
  );
};

// The UpdateProfileModal component
const UpdateProfileModal = ({ isOpen, onClose, initialData, onUpdateSuccess }) => {
  const [formData, setFormData] = useState({
    business_name: '',
    phone: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState(null); // For success messages
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFormData({
        business_name: initialData?.business?.business_name || '',
        phone: initialData?.user?.phone || '',
      });
      setErrors({}); // Also clear previous errors
      setSuccessMessage(null); // Reset success message
    }
  }, [isOpen]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);

    e.preventDefault();
    try {
      // that expects this data and uses the stored procedure.
      const response = await api.post('/update-profile', formData);

      setSuccessMessage('Profile updated successfully!');
      setFormData({
        business_name: '',
        phone: ''
      });

      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (error) {
      console.error('Failed to update profile:', error);
      errorHandler(error, setErrors);

    } finally {
      setLoading(false);
    }

    console.log("Submitting profile data:", formData);
    // In a real application, you would send this data to your backend API
    console.log("Profile Updated (mock)!");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Update Profile">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="business_name" label="Business Name" />
          <input // Changed from TextInput to native input
            id="business_name"
            name="business_name"
            type="text"
            value={formData.business_name}
            onChange={handleChange}
            placeholder="Your business name"
            className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm ${errors.business_name ? 'border-red-500 focus:ring-red-500' : ''}`}
            aria-invalid={errors.business_name ? "true" : "false"}
            aria-describedby="company-name-error" // Added aria-describedby for accessibility
          />
          <ShowValidationMessage error={errors.business_name} />
        </div>
        <div>
          <Label htmlFor="phone" label="Phone Number" />
          <input // Changed from TextInput to native input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            placeholder="(123) 456-7890"
            className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm ${errors.phone ? 'border-red-500 focus:ring-red-500' : ''}`}
            aria-invalid={errors.phone ? "true" : "false"}
            aria-describedby="phone-error" // Added aria-describedby for accessibility
          />
          <ShowValidationMessage error={errors.phone} />
        </div>
        <button type="submit" className="px-6 py-2 bg-primary-brand text-white rounded-md hover:bg-primary-brand-darker transition-colors shadow-sm">
          

        {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              Changing...
            </>
          ) : 'Update'}
        </button>
      </form>
    </Modal>
  );
};

export default UpdateProfileModal;
